import { render, staticRenderFns } from "./Stadistics.vue?vue&type=template&id=1a01febe"
import script from "./Stadistics.vue?vue&type=script&lang=js"
export * from "./Stadistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports